import React, { useState } from 'react';
import { FiSearch, FiX, FiFileText, FiInfo, FiBox } from 'react-icons/fi';
import { FaBuilding } from 'react-icons/fa';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

// Combined data: Customer Invoices (FA...) and Supplier Invoices (SI... / PROV...)
const initialData = [
  { id: 216, inv: 'FA2605-0041', date: '05/20/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '2,500.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
  
  // 修正後的供應商單據 (SI2605-0001)，日期較新，ID 調高為 303
  { id: 303, inv: 'SI2605-0001', date: '05/15/2026', ref: 'MULTIPLE', desc: '多項商品合併 (Consolidated)', extraDesc: '會展優惠 / 納米美白去斑精華 等', amt: '2,800.00', tax: '0', third: 'Mei Yik Company', country: 'Hong Kong', hasInfo: false },
  
  { id: 215, inv: 'FA2602-0095', date: '02/13/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '1,000.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
  { id: 214, inv: 'FA2602-0094', date: '02/10/2026', ref: 'WOW_CURL_CREAM', desc: 'WOW CURL CREAM', extraDesc: '(Country of origin: South Korea)', amt: '100.00', tax: '0', third: 'ALISON TAM', country: 'Hong Kong', hasInfo: false },
  { id: 212, inv: 'FA2602-0093', date: '02/06/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '250.00', tax: '0', third: 'SHEREE', country: 'United Kingdom', hasInfo: true },
  
  // 修正後的供應商單據 (SI2604-0001)，日期居中，ID 調為 302
  { id: 302, inv: 'SI2604-0001', date: '04/15/2026', ref: '8111M', desc: 'HYDRATANT CLEANSING MILK 200ml', extraDesc: '', amt: '420.00', tax: '0', third: 'AMICA BEAUTY SUPPLIES', country: 'Hong Kong', hasInfo: false },

  { id: 211, inv: 'FA2601-0092', date: '01/19/2026', ref: 'BOOSTER_SERUM', desc: 'BOOSTER SERUM 25', extraDesc: '(Country of origin: Japan)', amt: '550.00', tax: '0', third: 'WONG KI', country: 'Hong Kong', hasInfo: false },
  { id: 210, inv: 'FA2601-0092', date: '01/19/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '6,250.00', tax: '0', third: 'WONG KI', country: 'Hong Kong', hasInfo: false },
  { id: 209, inv: 'FA2601-0091', date: '01/19/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '12,000.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
  { id: 208, inv: 'FA2601-0090', date: '01/05/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '6,000.00', tax: '0', third: 'AO IEONG CHI HONG', country: 'Hong Kong', hasInfo: false },
  { id: 207, inv: 'FA2601-0089', date: '01/02/2026', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '2,000.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
  
  // 修正後的供應商單據 (PROV15)，日期最舊，ID 調低為 301
  { id: 301, inv: '(PROV15)', date: '12/20/2025', ref: 'WOW_CURL_CREAM', desc: 'WOW CURL CREAM', extraDesc: '(Country of origin: South Korea)', amt: '20,000.00', tax: '0', third: 'WELL MAY INT.', country: 'China', hasInfo: false },

  { id: 206, inv: 'FA2512-0088', date: '12/16/2025', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '3,500.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
  { id: 205, inv: 'FA2512-0087', date: '12/01/2025', ref: 'C.R.P._MASK', desc: 'C.R.P. MASK', extraDesc: '', amt: '4,000.00', tax: '0', third: 'WONG CHING YEE', country: 'Hong Kong', hasInfo: false },
];

export default function InvoiceBinding() {
  // 強制更新 Cache Key 至 v7，載入修正 ID 後的資料
  const [data, setData] = useLocalState('invoice_binding_data_v7', initialData);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const sortedData = sortData(data, sortConfig);
  const displayedData = itemsPerPage === 'All' ? sortedData : sortedData.slice(0, itemsPerPage);

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) return <span className="text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 ml-1">▲</span>;
    return <span className="text-[10px] text-black ml-1">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
  };

  return (
    <div className="h-full flex flex-col bg-white font-sans">
      <div className="bg-[#a6e4e7] px-4 py-2 text-teal-800 text-[13px] border-b border-[#8ed1d4] flex justify-between items-center">
        <span>Bind invoice lines not already bound with a product accounting account ({sortedData.length})</span>
        
        {/* Pagination Dropdown */}
        <div className="flex items-center space-x-2">
          <select 
            value={itemsPerPage} 
            onChange={(e) => setItemsPerPage(e.target.value === 'All' ? 'All' : Number(e.target.value))}
            className="border border-gray-300 bg-white py-0.5 px-2 text-[11px] rounded-sm outline-none shadow-sm cursor-pointer text-gray-700 font-medium"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
            <option value="All">All</option>
          </select>
        </div>
      </div>

      <div className="flex-1 overflow-x-auto bg-white p-2">
        <table className="min-w-full border-collapse text-[12px] text-gray-800 border border-black shadow-sm">
          <thead>
            {/* Row 1: Headers */}
            <tr className="bg-[#a6e4e7] text-teal-900 select-none">
              <th onClick={() => handleSort('id')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group w-14">Id line <SortIcon column="id" /></th>
              <th onClick={() => handleSort('inv')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group w-28">Invoice <SortIcon column="inv" /></th>
              <th onClick={() => handleSort('date')} className="font-normal p-2 border border-black text-left text-teal-700 whitespace-nowrap cursor-pointer hover:bg-teal-200 group w-32">Date <SortIcon column="date" /></th>
              <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group w-36">Product ref. <SortIcon column="ref" /></th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-40">Product description</th>
              <th onClick={() => handleSort('amt')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group w-24">Amount <SortIcon column="amt" /></th>
              <th className="font-normal p-2 border border-black text-center text-teal-700 leading-tight w-16">Tax<br/>Rate</th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-32">Third-party</th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-24">Country</th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-20">VAT ID</th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-48">Accounting account su...</th>
              <th className="font-normal p-2 border border-black text-left text-teal-700 w-48">Bind line with the accounting ...</th>
              <th className="font-normal p-2 border border-black text-center w-12"><input type="checkbox" className="w-3 h-3 accent-[#0000a0]" /></th>
            </tr>
            {/* Row 2: Search Filters */}
            <tr className="bg-gray-50">
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black">
                <div className="flex flex-col space-y-1">
                  <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="From" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                  <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="to" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                </div>
              </td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" placeholder="%" className="w-full border border-gray-300 p-1 text-center outline-none h-7 shadow-inner text-gray-400 bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><input type="text" className="w-full border border-gray-300 p-1 outline-none h-7 shadow-inner bg-white" /></td>
              <td className="p-1 border border-black"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7 shadow-sm"><option></option></select></td>
              <td className="p-1 border border-black text-center">
                <div className="flex justify-center space-x-2 text-lg font-bold">
                  <FiSearch className="text-black cursor-pointer hover:opacity-70" title="Search" />
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            {displayedData.map((row, idx) => {
              // Determine if it's a supplier invoice (starts with SI or PROV) for accurate default account codes
              const isSupplier = row.inv.startsWith('SI') || row.inv.startsWith('(PROV');
              const defaultAccCode = isSupplier ? '601' : '701';
              const defaultAccText = isSupplier ? '601 - Purchases' : '701 - Sales of finished pr...';

              return (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black text-gray-800">{row.id}</td>
                  <td className="p-2 border border-black text-teal-800 whitespace-nowrap">
                    <FiFileText className={`inline mr-1.5 ${isSupplier ? 'text-orange-500' : 'text-[#5bc0be]'}`} />
                    {row.inv}
                  </td>
                  <td className="p-2 border border-black text-gray-800 whitespace-nowrap">{row.date}</td>
                  <td className="p-2 border border-black">
                    <div className="text-gray-800 font-medium whitespace-nowrap text-[12px]">
                      <FiBox className="inline mr-1.5 text-[#a08a50]" />
                      {row.ref}
                    </div>
                    <div className="text-gray-400 text-[10px] mt-0.5">{row.desc}</div>
                  </td>
                  <td className="p-2 border border-black text-gray-600 text-[11px]">{row.extraDesc}</td>
                  <td className="p-2 border border-black text-right text-teal-700 font-medium">{row.amt}</td>
                  <td className="p-2 border border-black text-right pr-4 text-gray-800">{row.tax}</td>
                  <td className="p-2 border border-black text-teal-800 whitespace-nowrap">
                    <FaBuilding className="inline mr-1.5 text-[#8b9dc3]" />
                    {row.third}
                  </td>
                  <td className="p-2 border border-black text-gray-800">{row.country}</td>
                  <td className="p-2 border border-black"></td>
                  <td className="p-2 border border-black text-[11px] text-gray-800 leading-tight">
                    <div className="mb-0.5 flex items-center">
                      1. Default for product: {defaultAccCode} {row.hasInfo && <FiInfo className="inline ml-1 text-gray-400 text-[10px]" />}
                    </div>
                    <div className="flex items-center">
                      2. This product: {defaultAccCode} {row.hasInfo && <FiInfo className="inline ml-1 text-gray-400 text-[10px]" />}
                    </div>
                  </td>
                  <td className="p-1.5 border border-black">
                    <select className="w-full text-[12px] bg-[#a6e4e7] border border-gray-300 p-1 outline-none text-gray-800 h-7 shadow-sm">
                      <option>{defaultAccText}</option>
                    </select>
                  </td>
                  <td className="p-2 border border-black text-center">
                    <input type="checkbox" defaultChecked className="w-3.5 h-3.5 accent-[#0000a0]" />
                  </td>
                </tr>
              );
            })}
            {displayedData.length === 0 && (
              <tr>
                <td colSpan="13" className="p-8 text-center text-gray-500 italic">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}